import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { of, switchMap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ExportToExcelService {
  readonly #httpClient = inject(HttpClient);

  export(
    resourceUrl: string,
    params?:
      | HttpParams
      | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> },
  ) {
    return this.#httpClient
      .get(resourceUrl, {
        responseType: 'blob',
        observe: 'response',
        params,
      })
      .pipe(
        switchMap(response => {
          const { body: excelData, headers } = response;
          const contentDisposition = headers.get('content-disposition');
          if (excelData && contentDisposition) {
            const filename = contentDisposition.split(';')[1].split('=')[1].replace(/\"/g, '');
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(excelData);
            link.download = filename;
            link.click();
          }
          return of(excelData);
        }),
      );
  }
}
